import Link from 'next/link';
import { forwardRef } from 'react';

export const RouterLink = forwardRef(({ ...other }, ref) => <Link ref={ref} {...other} />);
